const configuration = {
  facebookLink: "https://www.facebook.com/logistic.place",
  instagramLink: "https://www.instagram.com/logistic_place",
  mail: "logisticmobileapplication@gmail.com",
};

export default configuration;
